import { render, staticRenderFns } from "./SRPComponentPreview.vue?vue&type=template&id=4279a5de&scoped=true&"
import script from "./SRPComponentPreview.vue?vue&type=script&lang=js&"
export * from "./SRPComponentPreview.vue?vue&type=script&lang=js&"
import style0 from "./SRPComponentPreview.vue?vue&type=style&index=0&id=4279a5de&scoped=true&lang=css&"
import style1 from "./SRPComponentPreview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279a5de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/dealerdraft/dealerdraft/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCheckbox,VFlex,VImg,VLayout})
